import React, { useState } from "react";
import styles from "./FAQSection.module.css";
import { Container } from "../../common/Container";
import { faqData } from "../../../data/sharedSpendData";

const ChevronIcon: React.FC<{ open: boolean }> = ({ open }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
  >
    <path d="m19 9-7 7-7-7" />
  </svg>
);

export const FAQSection: React.FC = () => {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className={styles.section}>
      <Container>
        <div className={styles.header}>
          <div className={styles.eyebrow}>FAQ</div>
          <h2 className={styles.title}>Common questions</h2>
        </div>

        <div className={styles.list}>
          {faqData.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`}
              >
                <button
                  className={styles.question}
                  onClick={() => toggle(item.id)}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <ChevronIcon open={isOpen} />
                </button>
                <div
                  className={styles.answerWrapper}
                  style={{ maxHeight: isOpen ? "300px" : "0" }}
                >
                  <p className={styles.answer}>{item.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};
